import { apiRequest } from '@scc/lib'
import { toApiDate } from '@/lib/api-date'
import type { DateRange } from '@/modules/shared/types'
import type { SignalReport } from '@/modules/signal-report/types'

export interface SignalRepository {
  /** The derived shop-level report: hero, products, evidence, creators, thresholds. */
  getReport(clientId: string, range: DateRange): Promise<SignalReport>
}

export function createApiSignalRepository(): SignalRepository {
  return {
    async getReport(clientId, range) {
      const params = new URLSearchParams({
        start: toApiDate(range.from),
        end: toApiDate(range.to),
      })
      // Served by the signal service, not the analytics view route — Signal is
      // expected to leave this monorepo, so its endpoints stay under one prefix.
      return apiRequest<SignalReport>(`/signal/report?${params.toString()}`, {
        headers: { 'X-Store-Id': clientId },
      })
    },
  }
}

export const signalRepository = createApiSignalRepository()
